module.exports = __webpack_public_path__ + "img/kg-white.46ed20d1.svg";